import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { ComicCard, SectionHeader } from '@/components/base/ComicCard';
import { Link } from 'react-router-dom';
import { comics, categories } from '@/mocks/comics';
import { siteConfig } from '@/mocks/siteConfig';

function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20manga%20comic%20style%20background%20with%20warm%20gradient%20colors%20orange%20pink%20and%20cream%20tones%2C%20dynamic%20ink%20splash%20effects%2C%20Japanese%20and%20Chinese%20comic%20aesthetic%2C%20soft%20abstract%20shapes%2C%20clean%20minimalist%20composition%2C%20warm%20lighting%2C%20no%20text%2C%20modern%20artistic%20design&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="51漫画 - 全网热门漫画在线看"
          title="51漫画 - 全网热门漫画免费阅读平台"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center px-4">
        <div className="w-full max-w-3xl text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 font-bold leading-tight">
            全网热门漫画
            <br />
            <span className="text-accent-400">免费在线看</span>
          </h1>
          <p className="mt-5 md:mt-6 text-sm md:text-base text-background-200 max-w-xl mx-auto leading-relaxed">
            {siteConfig.description.replace(/🎯|🤩/g, '')}
          </p>
          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/hot-blood"
              className="whitespace-nowrap px-8 py-3 rounded-full bg-accent-500 text-background-50 text-sm md:text-base font-medium hover:bg-accent-600 transition-colors cursor-pointer"
            >
              立即阅读 <i className="ri-arrow-right-line ml-1"></i>
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap px-8 py-3 rounded-full border border-background-300/60 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/10 transition-colors cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

function HotComicsSection() {
  const hotComics = comics.slice(0, 8);

  return (
    <section className="px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <SectionHeader
          title="热门推荐"
          subtitle="大家都在看的精彩漫画"
          action={
            <Link
              to="/category/hot-blood"
              className="whitespace-nowrap text-sm text-accent-500 hover:text-accent-600 transition-colors flex items-center gap-1 font-medium"
            >
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {hotComics.map((comic, index) => (
            <ComicCard
              key={comic.id}
              {...comic}
              badge={index === 0 ? 'TOP 1' : index === 1 ? '推荐' : undefined}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

function StatsSection() {
  const stats = [
    { number: '12,000', suffix: '+', label: '海量漫画资源' },
    { number: '500', suffix: '万+', label: '活跃读者' },
    { number: '99.9', suffix: '%', label: '服务稳定性' },
  ];

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 leading-snug">
              为什么选择
              <br />
              51漫画平台
            </h2>
            <div className="mt-10 grid grid-cols-3 divide-x divide-foreground-200/40">
              {stats.map((stat, idx) => (
                <div key={idx} className="px-4 first:pl-0 last:pr-0">
                  <p className="text-3xl md:text-4xl font-bold text-accent-500">
                    {stat.number}<span className="text-xl">{stat.suffix}</span>
                  </p>
                  <p className="mt-2 text-xs md:text-sm text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-md aspect-square bg-gradient-to-br from-accent-100/60 to-accent-200/40 rounded-2xl overflow-hidden">
              <div className="absolute top-8 left-8 w-24 h-24 rounded-full bg-accent-300/40"></div>
              <div className="absolute top-20 right-10 w-20 h-32 rounded-3xl bg-accent-400/30"></div>
              <div className="absolute bottom-12 left-16 w-28 h-28 rounded-2xl bg-accent-200/50"></div>
              <div className="absolute bottom-16 right-6 w-16 h-16 rounded-full bg-accent-500/25"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function FeatureGridSection() {
  const features = [
    {
      title: '每日更新 · 追更不等待',
      desc: '热门漫画每日同步更新，第一时间推送最新章节，让你永不错过精彩剧情。',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20tone%20illustration%20of%20calendar%20pages%20flying%20with%20manga%20panels%2C%20dynamic%20composition%2C%20soft%20orange%20and%20cream%20colors%2C%20clean%20minimalist%20design%2C%20modern%20digital%20art%2C%20editorial%20style&width=800&height=500&seq=feature-img-01&orientation=landscape',
    },
    {
      title: '高清画质',
      desc: '全站漫画高清扫描，画质细腻，阅读体验舒畅。',
    },
    {
      title: '多端同步',
      desc: '电脑、手机、平板无缝切换，阅读进度自动同步。',
    },
  ];

  return (
    <section className="px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start justify-between gap-6 mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 leading-snug max-w-md">
            打造极致漫画
            <br />
            阅读体验
          </h2>
          <p className="text-sm text-foreground-500 max-w-xs leading-relaxed">
            从内容到技术，我们用心打磨每一个细节，只为给你最好的阅读感受。
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          <div className="md:col-span-2 bg-background-100 rounded-lg p-5 md:p-6">
            <div className="w-full aspect-[16/9] rounded-md overflow-hidden mb-4">
              <img
                src={features[0].image}
                alt={features[0].title}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <h3 className="text-base md:text-lg font-medium text-foreground-900">{features[0].title}</h3>
            <p className="mt-1.5 text-sm text-foreground-500 leading-relaxed">{features[0].desc}</p>
          </div>
          <div className="flex flex-col gap-4 md:gap-5">
            {features.slice(1).map((feat, idx) => (
              <div key={idx} className="flex-1 bg-background-100 rounded-lg p-5 md:p-6 flex flex-col justify-center">
                <h3 className="text-base md:text-lg font-medium text-foreground-900 text-center">{feat.title}</h3>
                <div className="mt-4 flex justify-center">
                  <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className={`${idx === 0 ? 'ri-image-line' : 'ri-device-line'} text-2xl text-accent-500`}></i>
                  </div>
                </div>
                <p className="mt-3 text-sm text-foreground-500 text-center leading-relaxed">{feat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function CategoriesSection() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeader
          title="漫画分类"
          subtitle="按分类浏览，快速找到你想看的"
        />
        <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-300/60 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-accent-100 flex items-center justify-center group-hover:bg-accent-500 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl text-accent-500 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <span className="text-xs md:text-sm text-foreground-700 font-medium whitespace-nowrap">{cat.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function LatestUpdatesSection() {
  const latestComics = [...comics].sort(() => Math.random() - 0.5).slice(0, 8);

  return (
    <section className="px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <SectionHeader
          title="最新更新"
          subtitle="刚刚更新的精彩章节"
          action={
            <Link
              to="/category/fantasy"
              className="whitespace-nowrap text-sm text-accent-500 hover:text-accent-600 transition-colors flex items-center gap-1 font-medium"
            >
              更多更新 <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} {...comic} />
          ))}
        </div>
      </div>
    </section>
  );
}

function CTASection() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 font-bold">
          准备好开始你的漫画之旅了吗？
        </h2>
        <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-lg mx-auto leading-relaxed">
          加入数百万读者，在51漫画发现你最爱的漫画作品，随时随地畅享阅读乐趣。
        </p>
        <Link
          to="/category/hot-blood"
          className="whitespace-nowrap mt-8 inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer"
        >
          开始免费阅读 <i className="ri-arrow-right-line"></i>
        </Link>
        <div className="mt-12">
          <img
            src="https://readdy.ai/api/search-image?query=Horizontal%20banner%20showing%20abstract%20manga%20panels%20and%20comic%20page%20layout%20with%20warm%20cream%20and%20soft%20orange%20gradient%20background%2C%20minimalist%20clean%20design%2C%20modern%20digital%20art%2C%20editorial%20style%2C%20no%20text&width=1200&height=300&seq=cta-banner-01&orientation=landscape"
            alt="51漫画阅读体验"
            className="w-full rounded-lg"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotComicsSection />
        <StatsSection />
        <FeatureGridSection />
        <CategoriesSection />
        <LatestUpdatesSection />
        <CTASection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "51漫画",
            url: "https://www.51comic.com",
            description: siteConfig.description.replace(/🎯|🤩/g, ''),
            potentialAction: {
              "@type": "SearchAction",
              target: "https://www.51comic.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "51漫画",
            url: "https://www.51comic.com",
            description: siteConfig.description.replace(/🎯|🤩/g, ''),
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "400-888-5151",
              contactType: "customer service",
              availableLanguage: "Chinese",
            },
            address: {
              "@type": "PostalAddress",
              addressLocality: "北京",
              addressRegion: "朝阳区",
              streetAddress: "望京SOHO T1座12层1206室",
            },
          }),
        }}
      />
    </>
  );
}